<template>
	<div id="app" v-if="finishedLoadingComponents" :style="anyModalOpen ? { height: '100vh', overflow: 'hidden' } : null">
		<transition name="app-fade" mode="out-in">
			<auth v-if="!logged" @login="login" />
			<div v-else>
				<header v-show="!isFullscreen">
					<logo-headNav @logout="logout" @info="resetTutorial" ref="headnav">
						<template #logo>
							<div class="logoAndVersionContainer" @click="() => { isHoveringLogo = false }"
								@mouseover="() => { isHoveringLogo = true }" @mouseleave="() => { isHoveringLogo = false }">
								<div class="logoWrapper">
									<b-img v-if="!isHoveringLogo" class="tmhub" center
										:src="require('./assets/tmHub_white.png')" fluid />
									<b-img v-else center class="mtwLogo" :src="require('./assets/mtw_white.png')" fluid />
								</div>
								<strong>v1.1.28</strong>
							</div>
						</template>
					</logo-headNav>

					<menu-sidebar @hideSideBar="hideSideBar()" @showSideBar="showSideBar()" />
				</header>

				<div id="main">
					<lost-connection-overlay :failedConnectionWithAxios="failedConnectionWithAxios" />
					<main :style="mainStyle">
						<transition name="router-fade" mode="out-in">
							<router-view @toggleFullscreen="toggleFullscreen" :key="$route.params.id" />
						</transition>
					</main>
				</div>

				<!-- New compact overlay component -->


				<comment-alarm-modal />
				<portal-target name="modals" multiple />
				<portal-target name="progressModals" multiple />
			</div>
		</transition>
		<ResultModalOverlay :open="resultModal.open" :payload="resultModal.payload" :i18n="$i18n" @close="closeResultModal"
			@action="onResultAction" />
	</div>
</template>
  
<script>
import { loadRoutes } from './routes.js'
import Auth from './pages/Auth.vue';
import { videoSyncManager } from "@/domain/GlobalFunctions/videoSyncManager";

import LostConnectionOverlay from './components/shared/LostConnectionOverlay/index.vue';
import ResultModalOverlay from './components/ResultModalOverlay.vue';


import resultModalMixin from './mixins/resultModal.mixin';
import notificationsMixin from './mixins/notifications.mixin';
import authMixin from './mixins/auth.mixin';
import layoutMixin from './mixins/layout.mixin';
import tourMixin from './mixins/tour.mixin';


export default {
	name: 'App',
	components: { Auth, LostConnectionOverlay, ResultModalOverlay },
	mixins: [resultModalMixin, notificationsMixin, authMixin, layoutMixin, tourMixin],

	data() {
		return {
			openModalCount: 0, // <<— global modal counter
		};
	},

	provide() {
		return {
			$modalManager: {
				increment: () => { this.openModalCount++; },
				decrement: () => { this.openModalCount = Math.max(0, this.openModalCount - 1); },
			}
		};
	},

	computed: {
		logged() {
			this.refresh; // reactive bump
			return this.$session.get('logged_id') > 0;
		},
		anyModalOpen() {
			return this.openModalCount > 0;
		}
	},

	watch: {
		anyModalOpen(locked) {
			const cls = 'modal-open-scroll-lock';
			document.body.classList.toggle(cls, locked);
		}
	},


	async created() {
		this.$session.start();
		this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		this.$session.set('isMobile', this.isMobile);

		this.userService = new this.$userService();
		this.dashboardService = new this.$dashboardService();
		this.variableService = new this.$variableService();
		this.alarmService = new this.$alarmService();
		this.statusService = new this.$statusService();
		this.alarmDataService = new this.$alarmDataService();

		this.$apiInterceptor.InterceptRequest(this);
		this.$apiInterceptor.InterceptResponse(this, this.$cookie, this.logout);

		this.id = this.$session.get('logged_id');
		console.log(this.id);
		if (this.id > 0) {
			const api_url = this.$session.get("api_url");
			if (api_url != undefined) this.$apiController.ChangeApiURL(api_url);
			console.log(localStorage.getItem("jwt_token"));

			loadRoutes(this.$router);
			this.startTour();
			this.startInterval();
			videoSyncManager.start(this, 30);
	
		} else {
			await this.tryRestoreSession();
	
		}

		this.loadApp();
	
	},

};
</script>
  
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;600;700&display=swap');
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css";
@import "https://site-assets.fontawesome.com/releases/v6.2.1/css/all.css";
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200');
@import "./assets/scss/main.scss";

/* Keep your existing rc styles if you want, or move to a partial */
.rc-overlay {
	position: fixed;
	inset: 0;
	z-index: 9999;
	background: rgba(0, 0, 0, .5);
	display: grid;
	place-items: center;
	padding: 20px;
}

.rc-modal {
	max-width: 92vw;
}

.material-symbol {
	font-family: 'Material Symbols Outlined';
	/* Variable font axes */
	font-variation-settings:
		'FILL' 0,
		/* 0 = outline, 1 = filled */
		'wght' 400,
		/* 100..700 */
		'GRAD' 0,
		/* -50..200 */
		'opsz' 24;
	/* 20..48, optical size */
}

.material-symbols-outlined {
	font-family: 'Material Symbols Outlined';
	font-variation-settings:
		'FILL' 0,   /* 0 = outline, 1 = filled */
		'wght' 400, /* 100..700 */
		'GRAD' 0,   /* -50..200 */
		'opsz' 24;  /* 20..48 */
}

</style>
  